import { render, staticRenderFns } from "./solutionPlans.vue?vue&type=template&id=c52db79a&scoped=true&"
import script from "./solutionPlans.vue?vue&type=script&lang=js&"
export * from "./solutionPlans.vue?vue&type=script&lang=js&"
import style0 from "./solutionPlans.vue?vue&type=style&index=0&id=c52db79a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52db79a",
  null
  
)

export default component.exports